import { defineMessages } from 'react-intl';

export const texts = defineMessages({
  noOptionsMessage: {
    id: 'Select.noOptionsMessage',
    description: 'No options message',
    defaultMessage: 'Hittade inga resultat'
  }
});
